import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-factura-global',
  templateUrl: './factura-global.component.html',
  styleUrls: ['./factura-global.component.scss']
})
export class FacturaGlobalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
